import { useQuery } from '@tanstack/react-query';
import { workspaceV1GetContextOptions } from '@antimatterhq/asl-api-ts-v1';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetWorkspaceContext = (
  {
    refetchInterval = false,
  }: {
    refetchInterval: number | false;
  } = { refetchInterval: false },
) => {
  const { workspace } = useWorkspace();

  return useQuery({
    ...workspaceV1GetContextOptions({
      ...defaultOptions(),
      path: { workspace },
    }),
    enabled: !!workspace,
    refetchInterval,
  });
};
